import { TableColumn } from 'react-data-table-component';

interface DataRow {
  amount: number;
  code: string;
  auth: string;
  message: string;
  value: number;
}

export const columns: TableColumn<DataRow>[] = [
  {
    name: 'Qtd.',
    selector: row => row.amount,
    width: '100px',
  },
  {
    name: 'Código',
    selector: row => row.code,
    minWidth: '280px',
    style: {
      cursor: 'pointer',
    },
  },
  {
    name: 'Autenticação',
    selector: row => row.auth,
    minWidth: '200px',
    style: {
      cursor: 'pointer',
    },
  },
  {
    name: 'Mensagem',
    selector: row => row.message,
    minWidth: '200px',
    style: {
      cursor: 'pointer',
    },
  },
  {
    name: 'Valor',
    selector: row => row.value,
    minWidth: '200px',
    style: {
      cursor: 'pointer',
    },
  },
];

// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  filter = 'filter',
}

// eslint-disable-next-line no-shadow
export enum FormDataGatewayPaymentInputName {
  startDate = 'startDate',
  endDate = 'endDate',
}
